import api from 'services/api';

/**
 * 재원패키지 저장 — BE FundPackageService 전용 API.
 * /common/save 의 BdFund.*Package* 는 거부된다.
 */
export async function saveFundPackagesApi(packages) {
  const res = await api.post('/bd/fund-package/save', { packages });
  return res.data || {};
}
